import KYC from "../../../jsx/components/Dashboard/KYC/kyc";

const KYCWrapper = () => {
  return <KYC />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.senior_underwriter,
];
export default constore(KYCWrapper);
